<template>
    <div class="main">
        <c-panel v-if="loading">
            <div class="loading-form" style="min-height: 220px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <c-panel v-else title="Emissão de Folha de Frequência (1 dia)" titleIcon="far fa-calendar-check">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <dl>
                            <dt>TURMA</dt>
                            <dd style="text-transform: uppercase;">
                                {{ turma.nome ? turma.nome : '-' }}
                                <span v-if="turma.curso && turma.curso.nome"> - ({{ turma.curso.nome }})</span>
                                <span v-if="turnoLabel"> - ({{ turnoLabel }})</span>
                            </dd>
                        </dl>
                        <dl>
                            <dt>INSTITUIÇÃO</dt>
                            <dd style="text-transform: uppercase;">
                                {{ turma.instituicao && turma.instituicao.nome ? turma.instituicao.nome : '-' }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Data *" key="data">
                            <el-input v-model="data" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="u-text-right u-mt-10">
                    <el-button type="primary" @click="emitPrint()">IMPRIMIR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        loading: false,
        turma: {},
        data: ''
    }),
    computed: {
        turnoLabel () {
            const t = (this.turma && (this.turma.turno || this.turma.turno === 0)) ? this.turma.turno : null
            if (t === null || t === undefined || t === '') return ''
            return this.$CONSTANTS.TURNO[t] || ''
        }
    },
    methods: {
        async loadTurma () {
            this.loading = true
            try {
                const turmaId = this.$route.params.turma_id
                const res = await this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/turma/getById/${turmaId}`,
                    this.$store.getters.getHeaderAuth
                )
                this.turma = res.data || {}
            } catch (error) {
                this.$store.commit('throwException', error)
            } finally {
                this.loading = false
            }
        },
        validate () {
            if (!this.data) return 'Informe a data.'
            const ok = this.$moment(this.data, 'DD/MM/YYYY', true).isValid()
            if (!ok) return 'Data inválida. Use dd/mm/aaaa.'
            return null
        },
        emitPrint () {
            const err = this.validate()
            if (err) return window.eventBus.$emit('alert', { msg: err, type: 'warning' })

            const turmaId = this.$route.params.turma_id
            window.eventBus.$emit('print', {
                url: '/api/pdf/renderFolhaFrequenciaDia',
                param: { turma_id: turmaId, data: this.data }
            })
        }
    },
    mounted () {
        this.data = this.$moment().format('DD/MM/YYYY')
        this.loadTurma()
    },
    watch: {
        '$route.params.turma_id': function () {
            this.loadTurma()
        }
    }
}
</script>
<style scoped>

    dl {
        min-height: 30px;
    }
</style>